<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pi_inoutno,pi_custname,pd_prodcode,pr_detail"
      placeholder="输入物料、客户、单号进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="{name: 'SaleSampleEdit', params: { item }}"
      >
        <div class="weui-cell__bd">
          <p>{{ item.pi_custname }}</p>
          <p class="list-item-muted">{{ item.pi_inoutno }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.pd_prodcode }}</p>
          <span class="list-item-status warning" v-if="item.pda_status == 1"
            >认证通过</span
          >
          <span
            class="list-item-status failing"
            v-else-if="item.pda_status == 2"
            >认证失败</span
          >
          <span class="list-item-status" v-else>未认证</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ items.length }}单</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/sale/prodinout/sample/list",
      params: {
        number: 1,
        size: 10,
      },
      filters: [
        {
          type: "date",
          name: "pi_date",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待认证",
              condition: "pda_status != 1",
            },
            {
              value: 2,
              label: "认证通过",
              condition: "pda_status =1",
            },
          ],
        },
      ],
    };
  },
};
</script>
<style scoped>
.failing {
  color: red;
  background: #f5f7fb;
}

</style>